// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1MmwB","label":"SetPasswdForm_label__1bLw3"};